import React, { useEffect, useState } from "react";
import {
  getTripsCreatedAPI,
  getTripsCreatedByStateAPI,
} from "../../../../../api/modules";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import PaginationList from "../../../../../components/organisms/pagination-list/PaginationList";
import CardItemOfferTravel from "../../../components/molecules/CardItemOfferTravel";
import { useSelector } from "react-redux";

const ContainerList = styled.div`
  overflow-y: overlay;
  padding-right: 10px;
`;

const RowStyled = styled(Row)`
  position: relative;
  width: 100%;
  bottom: 0px;
  margin-top: 20px;
`;

const DivEmpty = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
`;

const MyOffers = (props) => {
  const spinner = useSelector((state) => state.appReducer.isLoading);
  const history = useHistory();
  const location = useLocation();
  const INITIAL_STATE = {
    total: 0,
    items: [],
  };
  const [tripStateOne, setTripStateOne] = useState(INITIAL_STATE);
  const [page, setPage] = useState(0);
  const numberList = 5;

  const INITIAL_ENTITY = {
    items: [],
    total: 0,
  };

  useEffect(() => {
    fetchData(numberList, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async (limit = numberList, from = 0) => {
    const tripsResponse = await getTripsCreatedByStateAPI(numberList, from);
    const { total, trips } = tripsResponse;
    if (trips) {
      setTripStateOne({
        ...INITIAL_STATE,
        total,
        items: trips,
      });
    } else {
      setTripStateOne({
        ...INITIAL_STATE,
      });
    }
  };

  const handlePreviewPage = () => {
    fetchData(numberList, numberList * page - numberList);
    setPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    setPage((prev) => prev + 1);
    fetchData(numberList, numberList * (page + 1));
  };
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <ContainerList>
              {
                tripStateOne.items.map((trip, index) => (
                  <CardItemOfferTravel
                    onClick={() => {
                      const { _id } = trip;
                      history.push(
                        `/app/list-travels?state=0&tripId=${_id || "0"}`
                      );
                    }}
                    idTravel={trip._id}
                    product={trip.product}
                    postulations={trip.postulation_pending}
                    originName={trip.origin_site.site_name}
                    destinyName={trip.destiny_site.site_name}
                    withdrawDate={trip.withdraw_date}
                    deliveryDate={trip.delivery_date}
                    state="Pendientes"
                    key={index}
                    showId={trip.id_trip}
                  >
                    <strong>{location.site_name}</strong> {location.address}
                  </CardItemOfferTravel>
                ))
              }
              {tripStateOne.items.length === 0 && (
                <DivEmpty>
                  {!spinner ? (
                    <h2 className="font-weight-bold h3 text-center">
                      Aún no tenés ninguna oferta
                    </h2>
                  ) : null}
                </DivEmpty>
              )}
            </ContainerList>
          </Col>
        </Row>
      </Container>
      <RowStyled>
        <Col md="12">
          <PaginationList
            items={tripStateOne.items}
            total={tripStateOne.total}
            currPage={page}
            handlePreviewPage={handlePreviewPage}
            handleNextPage={handleNextPage}
            numberList={numberList}
          />
        </Col>
      </RowStyled>
    </>
  );
};

MyOffers.propTypes = {};

export default MyOffers;
